import { markRaw } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import {
  JobShareActionColumnFragmentDoc,
  JobShareCompanyColumnFragmentDoc,
  JobShareCompanyColumnFragment,
  JobShareCreatedAtColumnFragmentDoc,
  JobShareCreatedAtColumnFragment,
  JobShareOrderByColumn,
  SortOrder,
} from '@/gql/graphql'
import JobShareActionColumn from '@/components/GraphqlDataTable/columns/JobShare/JobShareActionColumn.vue'
import JobShareCompanyColumn from '@/components/GraphqlDataTable/columns/JobShare/JobShareCompanyColumn.vue'
import JobShareCreatedAtColumn from '@/components/GraphqlDataTable/columns/JobShare/JobShareCreatedAtColumn.vue'
import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'

const columns: ColumnMaps = {
  JobShareCompanyColumn: {
    fragment: JobShareCompanyColumnFragmentDoc,
    component: markRaw(JobShareCompanyColumn),
    columnDef: {
      title: $t('Company'),
      key: 'job_share_company',
      renderUsing: {
        component: markRaw(JobShareCompanyColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Company',
        extraction: (row: JobShareCompanyColumnFragment) => row.job?.company?.name ?? '',
      },
    ],
  },
  JobShareCreatedAtColumn: {
    fragment: JobShareCreatedAtColumnFragmentDoc,
    component: markRaw(JobShareCreatedAtColumn),
    columnDef: {
      title: $t('Shared'),
      key: 'job_share_created_at',
      orderAble: true,
      renderUsing: {
        component: markRaw(JobShareCreatedAtColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Shared at',
        extraction: (row: JobShareCreatedAtColumnFragment) => row.createdAt,
      },
    ],
    sort: [
      {
        name: `${JobShareOrderByColumn.CreatedAt}_${SortOrder.Desc}`,
        orderByColumn: JobShareOrderByColumn.CreatedAt,
        sortOrder: SortOrder.Desc,
        primaryText: $t('Shared at'),
        secondaryText: $t('New to old'),
        title: $t('Order by the shared date'),
      },
      {
        name: `${JobShareOrderByColumn.CreatedAt}_${SortOrder.Asc}`,
        orderByColumn: JobShareOrderByColumn.CreatedAt,
        sortOrder: SortOrder.Asc,
        primaryText: $t('Shared at'),
        secondaryText: $t('Old to new'),
        title: $t('Order by the shared date'),
      },
    ],
  },
  JobShareActionColumn: {
    fragment: JobShareActionColumnFragmentDoc,
    component: markRaw(JobShareActionColumn),
    columnDef: {
      title: '',
      key: 'action',
      renderUsing: {
        component: markRaw(JobShareActionColumn),
        componentProps: (row) => ({ row }),
      },
      ignoreClickForRowSelection: true,
    },
    dataDescriber: [],
  },
}

export default columns
